import React from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';

type InputProps = {
  placeholder: string;
  rows?: number | string;
  type?: string;
  required?: boolean;
};

const useStyles = makeStyles({
  root: {
    marginTop: 16,
    '& .MuiInputBase-root': {
      borderRadius: 4,
    },
  },
});

const Input = ({
  placeholder,
  rows,
  type = 'text',
  required = false,
}: InputProps) => {
  const classes = useStyles();
  return (
    <TextField
      id="outlined-basic"
      label={placeholder}
      type={type}
      required={required}
      variant="outlined"
      classes={{
        root: classes.root,
      }}
      placeholder={placeholder}
      rows={rows}
      multiline={rows ? true : false}
      fullWidth
    />
  );
};

export default Input;
